export const REPORT_CAUSES_LIST_KEY = 'REPORT_CAUSES_LIST';
export const REPORT_CAUSES_ONE_KEY = 'REPORT_CAUSES_ONE_KEY';
